import React from "react";
import styled from "styled-components";

const IconLookingGlass = () => {
  return (
    <StyledIconLookingGlass  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.14 13.04">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="m12.88,11.55l-1.94-1.94c.73-1,1.16-2.23,1.16-3.55,0-3.34-2.71-6.05-6.05-6.05S0,2.71,0,6.05s2.71,6.05,6.05,6.05c1.38,0,2.64-.47,3.66-1.25l1.93,1.93c.17.17.39.26.62.26s.45-.08.62-.26c.34-.34.34-.9,0-1.24ZM1.75,6.05C1.75,3.68,3.68,1.75,6.05,1.75s4.3,1.93,4.3,4.3-1.93,4.3-4.3,4.3S1.75,8.42,1.75,6.05Z" stroke-width="0"/>
      </g>
    </StyledIconLookingGlass>
  )
};
export default IconLookingGlass;

const StyledIconLookingGlass = styled.svg`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1.125em;
  path {
    fill: currentColor;
  }
`